import { Component, computed, inject, Signal } from '@angular/core';
import { ProjectParticipantsForCompanyComponent } from '@app/components/project-participants/project-participants-for-company.component';
import { ProjectParticipantActionsService } from '@app/shared/services/actions/project-participant-actions.service';
import { ActiveProjectService } from '@app/shared/services/active-project.service';
import { ProjectParticipantsDataService } from '@app/shared/services/project-participants-data.service';
import { Company } from '@app/shared/types/models/company/company.model';
import { ProjectParticipant } from '@app/shared/types/models/project/project-participant';
import { Project } from '@app/shared/types/models/project/project.model';
import { UiPageWrapperComponent } from '@app/shared/ui/page-wrapper/ui-page-wrapper.component';
import { UiSpinnerDirective } from '@app/shared/ui/spinner/ui-spinner.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-industries',
  templateUrl: './project-participants-view.component.html',
  imports: [UiPageWrapperComponent, TranslatePipe, ProjectParticipantsForCompanyComponent, UiSpinnerDirective]
})
export class ProjectParticipantsViewComponent {
  private readonly projectParticipantActionsService: ProjectParticipantActionsService = inject(
    ProjectParticipantActionsService
  );
  private readonly projectParticipantsDataService: ProjectParticipantsDataService =
    inject(ProjectParticipantsDataService);
  private readonly activeProjectService: ActiveProjectService = inject(ActiveProjectService);

  protected activeProject: Signal<Project | undefined> = this.activeProjectService.activeProject;

  protected currentProjectParticipants: Signal<ProjectParticipant[]> = computed(() =>
    this.activeProject()?.id
      ? this.projectParticipantsDataService.getProjectParticipants(this.activeProject().id)()
      : []
  );

  protected companies: Signal<Company[] | undefined> = computed(() =>
    this.activeProject()?.id
      ? this.projectParticipantActionsService.getCompaniesForProjectParticipants(this.activeProject())()
      : []
  );

  protected participantsForCompany(company: Company): Signal<ProjectParticipant[]> {
    return computed(() => this.currentProjectParticipants()?.filter(_ => _.group()?.companyId == company.id) || []);
  }
}
